<template>
  <controller-frame title="Items" class="Items" v-if="mode === 'items'">
    <div class="container">
      <div class="item" @click="create">
        <div class="inner">
          <faicon class="icon" icon="plus" />
          <p class="name m-ellipsis">新規作成</p>
        </div>
      </div>
      <div class="item" v-for="({ key, imageKey, text }, i) in items" :key="key" @click="current(key)" :style="{
        backgroundImage: url(imageKey)
      }">
        <div class="inner">
          <p class="name m-ellipsis">{{text}}</p>
          <div class="actions">
            <a @click.stop="index(key, i - 1)">←</a>
            <a @click.stop="index(key, i + 1)">→</a>
          </div>
        </div>
      </div>
    </div>
  </controller-frame>
</template>

<script>
import controllerFrame from '../frames/controller'
export default {
  components: { 'controller-frame': controllerFrame },
  computed: {
    items() {
      return this.$store.getters['items/$sorted']
    },
    mode() {
      return this.$store.getters['local/mode']
    },
    url() {
      return this.$store.getters['images/getBackgroundUrl']
    }
},
  methods: {
    create() {
      return this.$store.dispatch('items/$create', {
        text: '',
        imageKey: null
      })
    },
    current(key) {
      return this.$store.commit('items/$checkout', key)
    },
    index(key, index) {
      this.$store.dispatch('items/$index', { key, index })
    }
  }
}
</script>

<style scoped>
.Items {
}
.container {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.item {
  margin: 4px;
  width: 72px;
  height: 48px;
  background-size: cover;
  background-position: 50% 50%;
  cursor: pointer;
}
.inner {
  position: relative;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
}
.actions {
  padding: 0 2px;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  justify-content: space-between;
}
.actions a {
  color: #222;
  font-size: 10px;
}
.icon {
  position: absolute;
  top: 25%;
  left: 25%;
  width: 50%;
  height: 50%;
}
p {
  box-sizing: border-box;
  padding: 5px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: #000;
  font-size: 10px;
  text-align: center;
}
</style>
